
export default {
  name: 'MegasredaContentRecommendationsPreview',
  data() {
    return {
      recommendation: null,
      target: null,
      isVisible: false,
      scrollTop: 0,
    }
  },

  computed: {
    publishDateFormat() {
      const date = new Date(this.recommendation.publishDate)
      const dd = ('0' + String(date.getDate())).slice(-2)
      const MM = ('0' + String(date.getMonth() + 1)).slice(-2)
      const yy = ('0' + String(date.getFullYear() % 100)).slice(-2)
      const hh = ('0' + String(date.getHours())).slice(-2)
      const mm = ('0' + String(date.getMinutes())).slice(-2)
      const ss = ('0' + String(date.getSeconds())).slice(-2)

      return `${dd}.${MM}.${yy}, ${hh}:${mm}:${ss}`
    },
    shareTitle() {
      if (this.recommendation.title) {
        return this.recommendation.title
      } else if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
    shareDescription() {
      const text = this.recommendation.text
      if (text?.blocks?.length) {
        let preText = text.blocks.filter((block) => block.type === 'paragraph')
        preText = preText.slice(0, 3).map((p) => {
          return p.data.text
        })

        preText = preText.join(' ')
        const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
        return sanitizeText
      }
      return null
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR', 'ACCOUNTER'].includes(role)
      )
    },

    isAuthor() {
      if (this.recommendation?.author?._id) {
        return this.$auth?.user?._id === this.recommendation?.author._id
      } else {
        return false
      }
    },
    authorName() {
      if (this.recommendation?.author?.type === 'COMPANY') {
        return this.recommendation?.author.company.title
          ? this.recommendation?.author?.company?.title
          : this.recommendation?.author?.username
      } else {
        return this.recommendation?.author?.profile?.firstName &&
          this.recommendation?.author?.profile?.lastName
          ? `${this.recommendation?.author?.profile?.firstName} ${this.recommendation?.author?.profile?.lastName}`
          : this.recommendation?.author?.username
      }
    },
    preText() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          const preText = text.blocks.find(
            (block) => block.type === 'paragraph'
          )
          const sanitizeText = preText?.data?.text.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        }
      }
      return null
    },
  },

  beforeDestroy() {
    this.close()
  },

  methods: {
    async fetchRecommendation(id) {
      const { recommendation, target } = await this.$axios.$get(
        `/recommendations/${id}`
      )
      this.recommendation = recommendation
      this.target = target

      this.setView()
    },

    setView() {
      this.$axios.$post('/activity/view/recommendation', {
        username: this.author?.username,
        recommendationId: this.recommendation._id,
      })
    },
    update() {
      this.$emit('update')
    },

    goToPage() {
      this.$router.push(
        `/${this.target.username}/recommendations/${this.recommendation._id}`
      )
      this.close()
    },
    async open(recommendationId) {
      const { body, documentElement } = document
      this.scrollTop = documentElement.scrollTop
      body.style.top = `-${this.scrollTop}px`
      document.body.classList.add('not-overflow')
      this.isVisible = true
      await this.fetchRecommendation(recommendationId)
    },

    close() {
      this.recommendation = null
      this.target = null
      const { body, documentElement } = document
      document.body.classList.remove('not-overflow')
      documentElement.scrollTop = this.scrollTop
      body.style.removeProperty('top')
      this.isVisible = false
    },
  },
}
